import React from 'react';
import '../../BarManagementSection/WhyChoose/Choose.css';

function WhySpecial() {
    return (
        <div className='choose-outer'>
            <div className="choose-inner" >
                <div className="choose-upper">
                    <p></p>
                    <h2 className="header-text">
                        Why Choose This Course?
                    </h2>
                </div>
                <div className="choose-lower">
                    <p className="letter-text">
                        In addition to core hospitality training, the Diploma in Hotel Management at LIMS includes specialized modules in Personality Development, Communication Skills, and Customer Service, ensuring students are industry-ready both professionally and personally. With access to world-class training facilities and global best practices from the USA and Australia, students receive an international standard of education that enhances their competence and confidence in real-world hospitality settings.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default WhySpecial
